/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
==========================================================================================*/


const requestConfig = {

  url: 'https://www.xglhc528.com/admin0426/'

}

export default requestConfig
